import { AdHalfPopup } from '@internal/hy-ui-components';
import React, { useState } from 'react';
import { onAdClick } from 'src/utils/ad';
import { Carousel } from 'zarm';
import './index.scss';

interface AdState {
  /** 广告图片地址 */
  attachmentDomain: {
    attachmentDownloadUrl: string
  };
  /** 半弹窗图片域 */
  popUpAttachmentDomain?: {
    attachmentDownloadUrl: string
  };
  /** 广告类型 */
  adType: number;
  /** 广告跳转地址 */
  adRequestUrl: string;
  /** 广告名称 */
  adName: string;
  targetAppId?: string,
  extraData?: string
}

const FooterBanner = (props) => {
  const { bannerList, showClose, bottomOffset } = props;
  const sliceBannerList = bannerList.slice(0,5); // 只显示前5个

  const [halfPopupVisible, setHalfPopupVisible] = useState(false);
  const [halfPopupImageUrl, setHalfPopupImageUrl] = useState('');
  const [visible, setVisible] = useState(true);

  const bannerClick = (item) => {
    const { adRequestUrl = '', adType = '', adName = '', appId = '', extraData, adPosition, adNo, popUpAttachmentDomain } = item;
    onAdClick({
      adRequestUrl,
      adType,
      adName,
      adPosition,
      adNo,
      appId,
      extraData,
      popupAttachmentDownloadUrl: popUpAttachmentDomain && popUpAttachmentDomain.attachmentDownloadUrl,
      onHalfPopup: (imageUrl) => {
        setHalfPopupImageUrl(imageUrl);
        setHalfPopupVisible(true);
      },
    });
  };
  if( sliceBannerList.length === 0 || !visible ){
    return null;
  }
  return (
    <div className='footer-banner-comp' style={bottomOffset ? { bottom: `${bottomOffset}px` } : undefined}>
      {showClose ? (
        <div className='footer-banner-comp__close' onClick={() => setVisible(false)} />
      ) : null}
      {
        sliceBannerList.length > 1 && (
          <Carousel autoPlay={true} loop={true}>
            {sliceBannerList.map((item: AdState, index) => (
              <div className='carousel__item__pic' key={+index} onClick={() => bannerClick(item)}>
                <img className='carousel_item_img' src={item.attachmentDomain.attachmentDownloadUrl} alt='' draggable={false} />
              </div>
            ))}
          </Carousel>
        )
      }
      {
        sliceBannerList.length === 1 && (
          <img src={sliceBannerList[0].attachmentDomain.attachmentDownloadUrl} alt='' onClick={() => bannerClick(sliceBannerList[0])} />
        )
      }
      <AdHalfPopup
        visible={halfPopupVisible}
        imageUrl={halfPopupImageUrl}
        onClose={() => setHalfPopupVisible(false)}
      />
    </div>
  );
};
export default FooterBanner;
